import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Privacy from './pages/Privacy';
import TermsOfUse from './pages/TermsOfUse';
import Leave from './pages/Leave';
import Support from './pages/Support';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/termsOfUse" element={<TermsOfUse />} />
          <Route path="/leave" element={<Leave />} />
          <Route path="/support" element={<Support />} />
        </Routes>

        {/* Footer */}
        <footer className="footer">
          <div className="container">
            <div className="footer-content">
              <div className="footer-section">
                <h4 className="footer-title">ForTuber</h4>
                <p className="footer-text">AI-powered platform for YouTube creators</p>
                <p className="footer-company">© 2026 DIDI. All rights reserved.</p>
              </div>
              <div className="footer-section">
                <h4 className="footer-title">Legal</h4>
                <ul className="footer-links">
                  <li>
                    <Link to="/privacy" className="footer-link">
                      Privacy Policy
                    </Link>
                  </li>
                  <li>
                    <Link to="/termsOfUse" className="footer-link">
                      Terms of Service
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="footer-section">
                <h4 className="footer-title">Support</h4>
                <ul className="footer-links">
                  <li>
                    <Link to="/support" className="footer-link">
                      Contact Support
                    </Link>
                  </li>
                  <li>
                    <Link to="/leave" className="footer-link">
                      Delete Account
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="footer-section">
                <h4 className="footer-title">Contact</h4>
                <p className="footer-text">
                  <a
                    href="mailto:cddchingudeul@gmail.com"
                    className="footer-link"
                  >
                    cddchingudeul@gmail.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;

//http://fortuber.com/
//npm install --save-dev ajv 패키지 설치해야됨(새로운 reactjs의 경우 이게 필요함)

//firebase hosting 연결방법 -> 근데 vercel이 나음
//https://shiro21.tistory.com/426 도메인 연결하는 방법
//인증서 발급에 시간이 더 걸릴 수 있음,
//A레코드 말고도 TXT까지 추가로 설정하긴 했음

//브랜드 인증
//https://console.cloud.google.com/auth/audience?hl=ko&project=프로젝트키


//vercel로 연결함
//cddceo 깃헙으로 연결해놓음
//cafe24에 연결해야 됨
//ip 랑 cname이 있는데 ip만 연결해도 잘 됨
// 연결 방법은 vercel 대쉬보드 - 상단에 프로젝트 fortuber 선택 - 이후에 domains - 
// 지금은 연결해서 안보이지만 learn more 누르면 각각 ip, cname이 나옴 그중 ip만 복사해서 아래대로 실행하면 끝
// 연결은 약 5-10분정도만에 됐음
/**
 * Vercel 설정: Vercel 대시보드에서 프로젝트 설정(Settings > Domains)으로 이동하여 사용할 도메인을 입력합니다.
DNS 정보 확인: Vercel에서 제공하는 A 레코드(IP 주소) 또는 CNAME 정보를 확인합니다.
카페24 설정: 카페24 호스팅 센터 로그인 후 나의서비스관리 > 도메인 관리 > DNS 관리 > 호스트IP(A 레코드) 관리로 이동합니다.
레코드 추가: 도메인을 선택하고 Vercel에서 받은 A 레코드를 설정합니다.
연결 확인: 잠시 후(최대 1시간) Vercel 도메인 설정 페이지에서 도메인 상태가 'Valid'로 변경되면 연결이 완료된 것입니다.
카페24
 +2
 */

//구글서치에 도메인 소유권 확인 절차도 완료해놔야한다.
//https://help.cafe24.com/faq/domain/dns-management/google_search_console_dns_verification/